module.exports = __webpack_public_path__ + "img/signup-person.7fbc2506.png";